import { Box, Dialog, DialogContent, DialogTitle, Rating } from "@mui/material"
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import { purchaseIntentOptions } from "./feedbackData";
import MaterialButton from "../../../../components/MaterialButton";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { createFeedbackMutation, getFeedbackByID } from "../graphQL";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/LodingContext";

const FeedbackForm = (
    {open = false, setOpen,rowId, fetchYetToReceiveSampleTableData}) => {
        
    const navigate = useNavigate();
    const { userId } = useAuthData();
    const { setCirleLoading } = useLoading();
    const [viewPage, setViewPage] = useState(false);
    
    const [feedbackData, setFeedbackData] = useState({
        feedbackCollectedDate: "",
        purchaseIntent: "",
        productQualityRating: "",
        packagingQualityRating: "",
        valueForMoneyRating: "",
        overallRating: "",
        suggestedImprovements: "",
    });
    
    //fetch Feedback By iD
    useEffect(() => {
        if (!rowId?.rowId) return;

        const fetchFeedbackById = async () => {
            try {
                setCirleLoading(true);
                const response = await request(BASEURL, getFeedbackByID, {
                    sampleId: rowId.rowId,
                });
                const data = response.getFeedbackBySampleId.data;

                if (Array.isArray(data) && data.length > 0) {
                    setViewPage(true);
                    const responseData = data[0];

                    const matchedOption = purchaseIntentOptions.find(
                    (opt) => opt.label.toLowerCase() === responseData.purchaseIntent.toLowerCase()
                    );

                    setFeedbackData((prev) => ({
                    ...prev,
                    feedbackCollectedDate: responseData.feedbackCollectedDate,
                    purchaseIntent: matchedOption,
                    suggestedImprovements: responseData.suggestedImprovements,
                    productQualityRating: responseData.productQualityRating,
                    packagingQualityRating: responseData.packagingQualityRating,
                    valueForMoneyRating: responseData.valueForMoneyRating,
                    overallRating: responseData.overallRating,
                    }));
                } else {
                    // No data → treat as new entry
                    setViewPage(false);
                    setFeedbackData({
                    feedbackCollectedDate: "",
                    purchaseIntent: null,
                    productQualityRating: 0,
                    packagingQualityRating: 0,
                    valueForMoneyRating: 0,
                    overallRating: 0,
                    suggestedImprovements: "",
                    });
                }
            } catch (error) {
            console.error("Error Fetching Data", error);
            }
            finally{
                setCirleLoading(false);
            }
        };

        fetchFeedbackById();
    }, [rowId]);

    //Handle Submit Feedback
    const handleSubmitFeedback = async () => {
        try{
            setCirleLoading(true);
            const values = {
                sampleId: rowId.rowId,
                feedbackCollectedDate: feedbackData.feedbackCollectedDate,
                purchaseIntent: feedbackData.purchaseIntent?.value,
                productQualityRating: feedbackData.productQualityRating,
                packagingQualityRating: feedbackData.packagingQualityRating,
                valueForMoneyRating: feedbackData.valueForMoneyRating,
                overallRating: feedbackData.overallRating,
                suggestedImprovements: feedbackData.suggestedImprovements,
                submittedBy: userId
            }
            const response = await request(BASEURL, createFeedbackMutation, {
                input: values
            });
            const responseData = response.createProductFeedback;        
            const successStatus = responseData.success;
            const responseMessage = responseData.message;

            if(successStatus){
                Swal.fire({
                  position: "top",
                  icon: "success",
                  title: responseMessage,
                  showConfirmButton: true,
                }).then(() => {
                  navigate("/samples-and-feedback");
                  handleClose();
                });
            }
            else{
                Swal.fire({
                  position: "top",
                  icon: "error",
                  title: responseMessage,
                  showConfirmButton: true,
                }); 
            }
        }
        catch(error){
            console.error("Error Submitting Data",error);
        }
        finally{
            setCirleLoading(false);
            fetchYetToReceiveSampleTableData();
        }
    }
    //Handle Change
    const handleChange = (event, selectEvent) => {
        let feedbackState = { ...feedbackData };

        if (event?.target === undefined && selectEvent) {
            // Handling MaterialSelect
            switch (selectEvent.name) {
                case "purchaseIntent": {
                    feedbackState[selectEvent.name] = selectEvent.value;
                    break;
                }
            }
        } else if (event?.target) {
            const { name, value } = event.target;

            switch (name) {
            case "customerName": {
                const alphaNLengthRegex = /^([A-Za-z ]{1,20})$/;
                feedbackState[name + "Status"] = alphaNLengthRegex.test(value.trim())
                ? "success" : value === "" ? "unchecked" : "error";
                feedbackState[name] = value;
                break;
            }

            case "suggestedImprovements": {
                const alphaNLengthRegex = /^([A-Za-z ]{1,20})$/;
                feedbackState[name + "Status"] = alphaNLengthRegex.test(value.trim())
                ? "success" : value === "" ? "unchecked" : "error";
                feedbackState[name] = value;
                break;
            }

            case "feedbackCollectedDate": {
                feedbackState[name] = value;
                break;
            }

            default:
                feedbackState[name] = value;
                break;
            }
        }

    setFeedbackData(feedbackState);
    };

    //Handle change for Rating
    const handleRatingChange = (field) => (event, newValue) => {
        if (newValue >= 0 && newValue <= 5) {
            setFeedbackData((prevData) => ({
            ...prevData,
            [field]: newValue
            }));
        }
    };

    const checkAllFields = () => {
        let allowSubmit = false;
        if( feedbackData.feedbackCollectedDate &&
            feedbackData.purchaseIntent)
            {
                allowSubmit = true;
            }
        else{
            allowSubmit = false;
        }
        return allowSubmit;
    };

    const handleClose = () => {
        setOpen(false);
    };
  return (
    <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
            Feedback
        </DialogTitle>
        <DialogContent>
            <Box>
                <Grid container spacing={2}>
                    <Grid size={{ lg: 6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Feedback Collected Date <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                        </MaterialBox>
                  
                        <MaterialInput
                        name="feedbackCollectedDate"
                        type="date"
                        value={feedbackData.feedbackCollectedDate}
                        onChange={handleChange}
                        inputProps={{
                            max: new Date().toISOString().split("T")[0], // sets today's date as the max
                        }}
                        disabled={viewPage}
                        />
                    </Grid>
                    <Grid size={{ lg: 6, xs: 12, sm: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Purchase Intent <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="purchaseIntent"
                        options={purchaseIntentOptions}
                        value={purchaseIntentOptions.find(
                            (opt) => opt.value === feedbackData.purchaseIntent?.value
                        ) || null}
                        onChange={(option) =>
                            handleChange(undefined, { name: "purchaseIntent", value: option })
                        }
                        isDisabled={viewPage}
                        />
                    </Grid>
                   
                    {/* Product Quality */}
                    <Grid size={{ lg: 6, xs: 12, sm: 12 }} sx={{ display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
                        <MaterialBox mb={1}>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Product Quality 
                            </MaterialTypography>
                        </MaterialBox>
                    </Grid>
                    <Grid size={{ lg: 6, xs: 12, sm: 12 }}>
                        <Rating 
                        name="size-medium" 
                        defaultValue={0}
                        value={feedbackData.productQualityRating}
                        onChange={handleRatingChange("productQualityRating")}
                        disabled={viewPage}
                        />
                    </Grid>

                    {/* Packaging Quality */}
                     <Grid size={{ lg: 6, xs: 12, sm: 12 }} sx={{ display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
                        <MaterialBox mb={1}>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Packaging Quality 
                            </MaterialTypography>
                        </MaterialBox>
                    </Grid>
                    <Grid size={{ lg: 6, xs: 12, sm: 12 }}>
                        <Rating name="size-medium" 
                        defaultValue={0} 
                        value={feedbackData.packagingQualityRating}
                        onChange={handleRatingChange("packagingQualityRating")}
                        disabled={viewPage}
                        />
                    </Grid>
                    {/* Value For Money */}
                     <Grid size={{ lg: 6, xs: 12, sm: 12 }} sx={{ display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
                        <MaterialBox mb={1}>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Value For Money 
                            </MaterialTypography>
                        </MaterialBox>
                    </Grid>
                    <Grid size={{ lg: 6, xs: 12, sm: 12 }}>
                        <Rating name="size-medium" 
                        defaultValue={0} 
                        value={feedbackData.valueForMoneyRating}
                        onChange={handleRatingChange("valueForMoneyRating")}
                        disabled={viewPage}
                        />
                    </Grid>
                    {/* Overall  Rating  */}
                     <Grid size={{ lg: 6, xs: 12, sm: 12 }} sx={{ display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
                        <MaterialBox mb={1}>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Overall  Rating 
                            </MaterialTypography>
                        </MaterialBox>
                    </Grid>
                    <Grid size={{ lg: 6, xs: 12, sm: 12 }}>
                        <Rating name="size-medium" 
                        defaultValue={0} 
                        value={feedbackData.overallRating}
                        onChange={handleRatingChange("overallRating")}
                        disabled={viewPage}
                        />
                    </Grid>
                    <Grid size={{ lg: 12, xs: 12, sm: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Suggested Improvements 
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="suggestedImprovements"
                        value={feedbackData.suggestedImprovements}
                        onChange={handleChange}
                        disabled={viewPage}
                        multiline
                        rows={2}/>
                    </Grid>
                  
                </Grid>
            </Box>
           
            <MaterialBox
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <MaterialButton
                        sx={{ m: 2 }}
                        variant="gradient"
                        color="error"
                        size="small"
                        onClick={handleClose}
                      >
                        Cancel
                      </MaterialButton>
                         {!viewPage && (
                      <MaterialButton
                        sx={{ m: 2 }}
                        variant="gradient"
                        color="dark"
                        size="small"
                        onClick={handleSubmitFeedback}
                        disabled={!checkAllFields()}
                      >
                        Submit
                      </MaterialButton>
                      )}
                    </MaterialBox>
        </DialogContent>
    </Dialog>
  )
}

export default FeedbackForm